import { render, staticRenderFns } from "./InboxFilters.vue?vue&type=template&id=6cebd492&scoped=true&"
import script from "./InboxFilters.vue?vue&type=script&lang=js&"
export * from "./InboxFilters.vue?vue&type=script&lang=js&"
import style0 from "./InboxFilters.vue?vue&type=style&index=0&id=6cebd492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cebd492",
  null
  
)

export default component.exports